import { render, staticRenderFns } from "./ListPage.vue?vue&type=template&id=b6d8630e&"
import script from "./ListPage.vue?vue&type=script&lang=js&"
export * from "./ListPage.vue?vue&type=script&lang=js&"
import style0 from "./ListPage.vue?vue&type=style&index=0&id=b6d8630e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports